import { useState } from 'react';

function americanToDecimal(american) {
	const a = parseFloat(american);
	if (isNaN(a) || a === 0) return NaN;
	if (a > -100 && a < 100) return NaN;
	if (a > 0) return a / 100 + 1;
	return 100 / Math.abs(a) + 1;
}

function decimalToAmerican(decimal) {
	if (decimal >= 2) return Math.round((decimal - 1) * 100);
	return Math.round(-100 / (decimal - 1));
}

export const ParlayCalculator = () => {
	const [legs, setLegs] = useState([{ odds: '' }, { odds: '' }]);
	const [stake, setStake] = useState('');

	const addLeg = () => setLegs([...legs, { odds: '' }]);

	const removeLeg = (index) => {
		if (legs.length <= 2) return;
		setLegs(legs.filter((_, i) => i !== index));
	};

	const updateLeg = (index, value) => {
		const updated = [...legs];
		updated[index] = { odds: value };
		setLegs(updated);
	};

	const decimalOdds = legs.map(l => americanToDecimal(l.odds));
	const allValid = decimalOdds.every(d => !isNaN(d) && d > 1);
	const stakeNum = parseFloat(stake);

	let results = null;
	if (allValid && decimalOdds.length >= 2) {
		const combinedDecimal = decimalOdds.reduce((acc, d) => acc * d, 1);
		const combinedAmerican = decimalToAmerican(combinedDecimal);
		const impliedProb = (1 / combinedDecimal) * 100;
		const payout = !isNaN(stakeNum) && stakeNum > 0 ? stakeNum * combinedDecimal : null;
		const profit = payout ? payout - stakeNum : null;

		results = { combinedDecimal, combinedAmerican, impliedProb, payout, profit };
	}

	const handleReset = () => {
		setLegs([{ odds: '' }, { odds: '' }]);
		setStake('');
	};

	const formatAmerican = (odds) => odds > 0 ? `+${odds}` : `${odds}`;

	return (
		<div>
			<div className="calc-section">
				<h3 className="calc-section-title">Parlay Legs (American Odds)</h3>
				{legs.map((leg, i) => (
					<div key={i} className="calc-leg-row">
						<span className="calc-leg-number">{i + 1}.</span>
						<input
							className="calc-input"
							type="text"
							placeholder="-110"
							value={leg.odds}
							onChange={(e) => updateLeg(i, e.target.value)}
						/>
						{legs.length > 2 && (
							<button className="calc-remove-btn" onClick={() => removeLeg(i)}>✕</button>
						)}
					</div>
				))}
				<button className="calc-add-btn" onClick={addLeg}>+ Add Leg</button>
			</div>

			<div className="calc-section">
				<div className="calc-input-group" style={{ maxWidth: '200px' }}>
					<label className="calc-label">Stake ($)</label>
					<input
						className="calc-input"
						type="text"
						placeholder="100"
						value={stake}
						onChange={(e) => setStake(e.target.value)}
					/>
				</div>
			</div>

			{results && (
				<div className="calc-results">
					<h4 className="calc-results-title">Parlay Results</h4>
					<div className="calc-result-row">
						<span className="calc-result-label">Combined Odds (American)</span>
						<span className="calc-result-value">{formatAmerican(results.combinedAmerican)}</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Combined Odds (Decimal)</span>
						<span className="calc-result-value">{results.combinedDecimal.toFixed(4)}</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Implied Probability</span>
						<span className="calc-result-value highlight">{results.impliedProb.toFixed(2)}%</span>
					</div>
					{results.payout !== null && (
						<>
							<div className="calc-result-row">
								<span className="calc-result-label">Total Payout</span>
								<span className="calc-result-value">${results.payout.toFixed(2)}</span>
							</div>
							<div className="calc-result-row">
								<span className="calc-result-label">Profit</span>
								<span className="calc-result-value positive">${results.profit.toFixed(2)}</span>
							</div>
						</>
					)}
				</div>
			)}

			<button className="calc-reset-btn" onClick={handleReset}>Reset</button>
		</div>
	);
};
